import { useEffect } from "react";

const FreshWorksWidget = () => {
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!token || process.env.REACT_APP_SERVER !== "production") return;

    // Initialize Freshworks settings
    window.fwSettings = {
      widget_id: process.env.REACT_APP_FRESH_WORK_WIDGET_ID,
    };

    // Initialize Freshworks Widget using IIFE
    (() => {
      if (typeof window.FreshworksWidget !== "function") {
        const widget = (...args) => widget.q.push(args);
        widget.q = [];
        window.FreshworksWidget = widget;
      }
    })();

    // Create and append script
    const script = document.createElement("script");
    script.src = process.env.REACT_APP_FRESH_WORK_WIDGET_URL;
    document.body.appendChild(script);

    // Cleanup
    return () => document.body.removeChild(script);
  }, [token]);

  return null;
};

export default FreshWorksWidget;
